<template>
  <div class="mediaBackground" :width ="$vuetify.breakpoint.xs ? '70vw' : '30vw'" >
        <v-lazy
        v-model="isActive"
        :options="{
          threshold: .5
        }"
      >
    
  <v-card 
    :width ="$vuetify.breakpoint.xs ? '70vw' : '30vw'"
    class="mx-auto justify-center m4u_tertiary"
    flat
    height="100%"
  >  

    <div class="mediaDiv" v-if="mediatype === 2">
                   
      <a :href="sasKey" 
  target="popup" 
  onclick="window.open(sasKey,'popup','width=85vw,height=85vw'); return false;">
   <v-img 
      class="m4u_tertiary imageTag"
      max-width="80%"
      max-height="100%"
      :src="sasKey"
    >
    </v-img>
      </a>
    </div>


    <div class="mediaDiv" v-if="mediatype === 1">
        <video controls controlsList="nodownload" :src="sasKey" 
          width ="85%" class="videoTag"></video>
    </div>

  </v-card>
        </v-lazy>
  </div>
</template>
<script>

import EventService from '@/services/EventService.js'; 



export default {
   name: "MediaCardHome",

   props: ["mediaLocs", 
            "mediatype"],

  data() {
    return {
      isActive: false,
      sasKey: '',
      reload: 0,
           absolute: true,
      opacity: .5,
      overlay: false,
       }
    },

    mounted() {
    this.getSASKey();

  },

  computed: {
        
    user(){
    return this.$store.state.user
  },
    },
  
  methods: {

    async getSASKey() {
      // NEW - Use the eventService to call the getEvents() method

    if(this.mediaLocs === null) {
                    switch(this.mediatype) {
              case 1:
                this.sasKey = process.env.VUE_APP_IMAGEPATH + 'writing.png'

              case 2: 
                this.sasKey = process.env.VUE_APP_IMAGEPATH + 'interview.png'

              case 3:
                this.sasKey = process.env.VUE_APP_IMAGEPATH + 'recipe.png'

              case 4:
                this.sasKey = process.env.VUE_APP_IMAGEPATH + 'traditions.png'

              default:
                this.sasKey = process.env.VUE_APP_IMAGEPATH + 'writing.png'
            }
    } else {
      EventService.getSASKey(this.mediaLocs)
      .then(
        (sasKey => {
          this.$set(this, "sasKey", sasKey);
        }).bind(this)

      );
    }
    },

    
  }
};
</script>
<style lang="scss" scoped>
.card {
  background-position: center;
  background-size: cover;
  text-align: center;
}
.card-content {
  padding-top: 50px;
  margin-top: 200px;
  position: absolute;
  color: #fff;
  background-color: rgba(0, 0, 0, 0.35);
  top: 0;
  padding: 10px;
  height: 200px;
  width: 100%;

  }

  .imageTag {
    margin-top: 5px;
    justify-content: center;
    object-fit: contain;
    max-width: 100%;
    max-height: 100%;
  }

  
  .mediaBackground {
    color: "orange";
    width: 100%;
  }

  .mediaCard {
    margin-top: 5px;
    background-color: "primary";

  }

  .mediaDiv {
    height: 200px;
    justify-content: center;
  }

  .storySummary {
    width: 80%;
    text-align: left;
    height: 20px;
    overflow: hidden;
  }

  .videoTag {
    width: 100%;
    margin-top: 5px;
    max-height: 200px;
    align-content: center;
  }

  span {
    font-size: 18px;
    text-align: center;
    width: 100%;
    position: absolute;
    bottom: 10px;
    right: 0;
  }
  h2 {
    margin-top: 10px;
  }

</style>